import { FormPageLayout } from '@kirz/mui-admin';
import Grid from '@mui/material/Unstable_Grid2';
import { AccountGroupOutline } from 'mdi-material-ui';
import React, { useContext, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { UserContext } from 'contexts';
import { SettingsContext } from 'contexts/SettingsContext';

import { ClientFormFields } from './ClientFormFields';
import { useClientFormPreSubmit } from './useClientFormPreSubmit';

export function NewClient() {
  const [existingClient, setExistingClient] = useState<any>(null);
  const { user } = useContext(UserContext);
  const { leadSources } = useContext(SettingsContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const preSubmit = useClientFormPreSubmit(setExistingClient, 'individual');

  const phone = searchParams.get('phone');

  return (
    <FormPageLayout
      source="client"
      breadcrumbs={[
        { text: 'Клиенты', icon: AccountGroupOutline, href: '/clients' },
        { text: 'Новый клиент' },
      ]}
      defaultRoute="/clients"
      formProps={{
        defaultValues: {
          gender: 'male',
          userId: user.id,
          ...(phone && { phone }),
        },
      }}
      formSubmitterProps={{
        preSubmit,
        selection: ['id'],
        onSubmit: (item) => {
          navigate(`/clients/${item.id}`);
        },
      }}
    >
      <Grid container>
        <ClientFormFields
          existingClient={existingClient}
          leadSources={leadSources}
        />
      </Grid>
    </FormPageLayout>
  );
}
